import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";

const routeLabels: Record<string, string> = {
  '': 'Hjem',
  'blog': 'Blogg',
  'quad-research': 'Quadriceps Studie',
  'muscle-activation': 'Muskelaktivering',
  'adjustable-angle': 'Justerbar Ryggvinkel',
  'products': 'Produkter',
  'leg-extension': 'Liggende Justerbar Leg-extension',
  'chalk': 'Støvfri Kalk',
  'shaker': '100% Tett Plast Shaker',
  'pre-workout': 'Pre-Workout',
  'pre-workout-maxed': 'Peveo Maxed',
  'tennis-socks': 'Tennissokker (10-pakning)'
};

const handleProductsClick = () => {
  window.location.href = '/#products';
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  return (
    <div className="py-2 px-4 my-6 mt-4 bg-muted rounded-lg border border-border shadow-sm">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/" className="text-muted-foreground hover:text-primary font-medium transition-colors">
                {routeLabels['']}
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>

          {pathSegments.map((segment, index) => {
            const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
            const isLast = index === pathSegments.length - 1;

            return (
              <React.Fragment key={path}>
                <BreadcrumbSeparator className="text-muted-foreground" />
                <BreadcrumbItem>
                  {isLast ? (
                    <BreadcrumbPage className="text-foreground font-medium">
                      {routeLabels[segment] || segment}
                    </BreadcrumbPage>
                  ) : segment === 'products' ? (
                    <BreadcrumbLink>
                      <button onClick={handleProductsClick} className="text-muted-foreground hover:text-primary font-medium transition-colors">
                        {routeLabels[segment] || segment}
                      </button>
                    </BreadcrumbLink>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={path} className="text-muted-foreground hover:text-primary font-medium transition-colors">
                        {routeLabels[segment] || segment}
                      </Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </React.Fragment>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;
